import { playTone } from './audio';

// Two-note ascending chime (E5 → A5) for task completion. The minor-sixth
// interval reads as a quick, decisive "yes". Triangle wave for warmth.
//
// TODO: themes own their sounds (plan/03 §Theme contract). When M3 lands,
// move this synth into the default-theme module and let other themes
// override.
export function playDing(): void {
  playTone(659.25, 200, 0, 0.2, 'triangle');
  playTone(880.0, 280, 90, 0.2, 'triangle');
}
